let pageStartingTime: number | undefined;

let allWidgetLoadedTime: number | undefined;

let trackAllWidgetLoadedSent = false;

export const trackPageStarting = (): void => {
  pageStartingTime = performance.now();
};

export const trackAllWidgetLoaded = (): void => {
  if (trackAllWidgetLoadedSent || !pageStartingTime) {
    return;
  }
  allWidgetLoadedTime = performance.now();
  const duration = allWidgetLoadedTime - pageStartingTime;
  window.datadogRum.addAction('dashboard-all-widget-first-loaded', {
    executionTime: Math.floor(duration),
  });
  trackAllWidgetLoadedSent = true;
};
